export const DOCUMENT_TYPE_MAP: Record<string, string> = {
  CL1: "Congratulations Letter",
  TWL: "Termination Warning Letter",
  TL: "Termination Letter 1",
  TL2: "Termination Letter 2",
  WDL: "Withdrawal Letter",
  UAL: "IAR Concurrence Letter",
  URL: "IAR Denial Letter",
};
